export function renderHeader() {
  return `
    <header class="fixed top-0 left-0 right-0 z-50 border-b border-[#1C201E] bg-[#050505]/90 backdrop-blur-md px-6 lg:px-16 py-3.5 transition-all">
      <div class="max-w-7xl mx-auto flex items-center justify-between">
        <!-- Brandmark -->
        <a class="group flex flex-col tracking-tight" href="#">
          <span class="text-[10px] font-mono font-medium uppercase tracking-[0.22em] text-neutral-400 group-hover:text-white transition-colors">Developer & Architect</span>
          <span class="text-sm font-semibold tracking-tighter text-[#FAF8F5] uppercase font-display">Ranjika Nethpriya</span>
        </a>

        <!-- Center Navigation Links -->
        <nav class="hidden md:flex items-center gap-9 font-mono text-xs tracking-widest text-neutral-400">
          <a class="hover:text-white transition-colors py-1 hover:border-b hover:border-white" href="#about">01. ABOUT</a>
          <a class="hover:text-white transition-colors py-1 hover:border-b hover:border-white" href="#capabilities">02. CAPABILITIES</a>
          <a class="hover:text-white transition-colors py-1 hover:border-b hover:border-white" href="#projects">03. PROJECTS</a>
          <a class="hover:text-white transition-colors py-1 hover:border-b hover:border-white" href="#contact">04. CONTACT</a>
        </nav>

        <!-- Status Action Button (Pill per screen.png) -->
        <div class="flex items-center gap-3">
          <a class="inline-flex items-center gap-2 border border-white/20 bg-white/5 hover:bg-white hover:text-black transition-all duration-200 px-4 py-1.5 rounded-full text-xs font-mono font-medium text-[#F0EADC] tracking-wider" href="#contact">
            <span class="relative flex h-2 w-2 items-center justify-center">
              <span class="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-80 animate-ping"></span>
              <span class="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-300 terminal-beacon-green"></span>
            </span>
            <span>OPEN FOR IDEAS ↗</span>
          </a>
        </div>
      </div>
    </header>
  `;
}
